var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.405 8.22835C38.0133 8.84502 36.5183 9.26169 34.9466 9.45002C36.55 8.49002 37.78 6.96669 38.36 5.15335C36.86 6.04335 35.1983 6.69002 33.43 7.03669C32.0133 5.53002 29.9966 4.58669 27.7633 4.58669C23.4766 4.58669 20 8.06335 20 12.3534C20 12.96 20.07 13.55 20.2 14.12C13.745 13.795 8.02664 10.7034 4.19664 6.00669C3.52998 7.15669 3.14664 8.49002 3.14664 9.91002C3.14664 12.6034 4.51831 14.9817 6.59998 16.3734C5.32664 16.3317 4.12998 15.9834 3.08331 15.4017V15.5017C3.08331 19.2633 5.75831 22.4017 9.31164 23.115C8.65831 23.2917 7.97331 23.385 7.26664 23.385C6.76664 23.385 6.27831 23.3383 5.80498 23.2483C6.79331 26.3317 9.65998 28.5783 13.0583 28.6383C10.4 30.7217 7.05164 31.9633 3.41498 31.9633C2.78831 31.9633 2.16998 31.9267 1.56165 31.855C4.99831 34.06 9.07831 35.3433 13.4616 35.3433C27.745 35.3433 35.5533 23.5133 35.5533 13.2534C35.5533 12.92 35.545 12.5834 35.53 12.25C37.0466 11.1534 38.3633 9.78835 39.4016 8.23335L39.405 8.22835Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ecb1dcb5dd12a12dbbbd941377fd2c0f.svg";
export { ForwardRef as ReactComponent };